<div *ngIf="show" [class]="cssClass"></div>
